import PropTypes from 'prop-types';
import themeColors from '../assets/styles/themeColors';
import MissingInfo from '../pages/Review/MisingInfo';
import { formatName } from '../util/helpers/reviewHelper';
import Paragraph from './Paragraph/Paragraph';

const Name = ({ FirstName, LastName, MiddleName, Suffix }) => {
  const isEmptyName =
    FirstName === '' ||
    FirstName === ' ' ||
    FirstName === null ||
    LastName === '' ||
    LastName === ' ' ||
    LastName === null;
  if (isEmptyName) {
    return <MissingInfo />;
  }
  return (
    <Paragraph color={themeColors.colorTextXLLight} variant="normal">
      {formatName(FirstName, LastName, MiddleName, Suffix)}
    </Paragraph>
  );
};

Name.propTypes = {
  FirstName: PropTypes.string,
  LastName: PropTypes.string,
  MiddleName: PropTypes.string,
  Suffix: PropTypes.string,
};
export default Name;
